<template>
    <v-card>
        <v-card-title>
            VENTA POR DIVISA
        </v-card-title>
        <v-card-text>
            <ConsolidadoJuegoDivisaSearch :default="params" @search="search($event)" :loading="loading"/>
        </v-card-text>
        <v-card-text>
            <ConsolidadoJuegoDivisa :params="params" :loading.sync="loading"/>
        </v-card-text>
    </v-card>
</template>
<script>
    import ConsolidadoJuegoDivisa from '@components/entities/reporte/venta/juego-divisa';
    import ConsolidadoJuegoDivisaSearch from '@components/entities/reporte/venta/juego-divisa/search';

    export default {
        components: {
            ConsolidadoJuegoDivisa,
            ConsolidadoJuegoDivisaSearch
        },
        props: {
        
        },
        data: function() {
            const query = {... this.$route.query};

            for (const key in query) {
                if (Object.hasOwnProperty.call(query, key)) {
                    const element = query[key];
                    console.log(key, query[key], this.$lodash.isNumber(element));
                    query[key] = /^-?[\d.]+(?:e-?\d+)?$/.test(element) ? Number.parseFloat(element): element;
                }
            }

            return {
                params: {
                    daterange: [this.$luxon.now().toISODate(),this.$luxon.now().toISODate()],
                    ... query,
                },
                loading: false,
            }
        },
        created: function () {
            this.$store.dispatch('ui/layout/setTitle', '');
        },
        computed:{
            
        },
        methods:{
            search: function (params) {
                this.params = params;
            }
        },
    }
</script>
<tyle>

</tyle>